module.exports = __webpack_public_path__ + "img/V20.c885dcc9.jpg";